import {Component, Input, OnInit} from '@angular/core';
import {AlertController, NavController} from "ionic-angular";
import {DataProvider} from "../../providers/data/data";
import {Photo, Sector} from "../../models/data.model";
import {SectorPage} from "../../pages/sector/sector";
import {PhotosRoutesViewerPage} from "../../pages/photos-routes-viewer/photos-routes-viewer";

@Component({
  selector: 'sector-preview',
  templateUrl: 'sector-preview.html'
})
export class SectorPreviewComponent implements OnInit {

  @Input('siteId') siteId: number;
  @Input('sectorId') sectorId: number;
  @Input('isDeleteButton') isDelete: boolean;
  photosThumb: Photo[] = [];
  photos: Photo[] = [];

  constructor(public navCtrl: NavController,
              private data: DataProvider,
              public alertCtrl: AlertController) {
  }

  ngOnInit() {
    if (this.isSectorOffline()) {
      this.data.getPhotosOffline(this.getSector().photos)
        .then(photos64 => {
          this.photosThumb = [...photos64];
          this.photos = [...photos64];
        })
    }
    else {
      this.getSector().photos.forEach(photo => {
        this.photosThumb.push({
          name: photo,
          url: DataProvider.getPhotoUrl(photo, true)
        });
        this.photos.push({
          name: photo,
          url: DataProvider.getPhotoUrl(photo, false)
        });
      });
    }
  }

  protected deleteOfflineSector(event: Event, sector: Sector) {
    event.stopPropagation();
    this.alertCtrl.create({
      title: 'Supprimer le secteur',
      message: 'Voulez vous supprimer le secteur ' + sector.name + ' de vos secteurs Hors-connexion ?',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
        },
        {
          text: 'Supprimer',
          handler: () => {
            this.data.deleteSectorOffline(sector.siteId, sector.id);
          }
        }
      ]
    }).present().catch();
  }

  protected openSector(): void {
    this.navCtrl.push(SectorPage, {
      siteId: this.siteId,
      sectorId: this.sectorId
    }).catch();
  }

  protected isSectorOffline(): boolean {
    return this.data.isSectorOffline(this.sectorId);
  }

  protected openPhotosPaths(event: Event) {
    event.stopPropagation();
    this.navCtrl.push(PhotosRoutesViewerPage, {
      siteId: this.siteId,
      sectorId: this.sectorId,
      photos: this.photos
    }).catch();
  }

  protected getSector(): Sector { return this.data.getSector(this.siteId, this.sectorId); }

}



// WEBPACK FOOTER //
// ./src/components/sector-preview/sector-preview.ts